module.exports = __webpack_public_path__ + "static/banner-three-shape5-362d54d15c1d7799e53f9b1023ed94f6.png";